<script setup lang="ts">
import {GeneratedReport, ObjectSchema, ObjectValue} from "@/generated-report/interfaces";
import {ref} from "vue";
import FormSchema from "@/generated-report/components/form-schema/FormSchema.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {DialogClose} from "@/core/components/ui/dialog";
import {HeartPulse, X} from '@lucide/vue';
import DMPButton from "@/core/components/buttons/DMPButton.vue";
import MailizButton from "@/core/components/buttons/MailizButton.vue";

const props = defineProps<{
    report: GeneratedReport;
    schema: ObjectSchema;
    loading?: boolean;
}>();

const emits = defineEmits<{
    (e: 'save', data: ObjectValue): void;
}>();

const data = ref(props.report.edited_content ?? props.report.generated_content);
</script>

<template>
  <div class="bg-gray-100 py-4 flex flex-row items-center px-4 flex-shrink-0 justify-between">
    <div class="flex gap-4">
      <HeartPulse class="w-8 h-8 text-primary" />
      <h1 v-if="report.completed_at" class="text-black">
        Rapport généré le {{ (new Date(report.completed_at)).toLocaleString() }}
      </h1>
    </div>
    <DialogClose as-child>
      <X />
    </DialogClose>
  </div>
  <div class="flex-1 overflow-y-auto pr-4">
    <p class="text-gray-600 text-sm">
      <strong>Avertissement :</strong> Ce rapport a été généré par une intelligence artificielle. Veuillez vérifier le
      contenu avant l'impression.
    </p>
    <FormSchema
      v-model="data"
      :schema="schema"
    />
  </div>
  <div class="flex justify-end gap-4 flex-shrink-0 pt-2">
    <DMPButton />
    <MailizButton />
    <BaseButton primary :loading="loading" @click="emits('save', data)">
      Sauvegarder les modifications et imprimer
    </BaseButton>
    <DialogClose>
      <BaseButton primary>
        Terminer
      </BaseButton>
    </DialogClose>
  </div>
</template>

<style scoped>

</style>
